module.exports = __webpack_public_path__ + "media/images/Logo-Crypto-60022fc670fbdfd437cfd80fbcc473eb.png";